import MiniForm from './MiniForm.styled';

export default MiniForm;
